import React from "react";
import SwipeNav from "../../Components/SwipeNav/SwipeNav";
import Overview from "./Overview/Overview";
import Outages from "./Outages/Outages";
import HowWorks from "./HowWorks/HowWorks";

let Components = [<Overview />, <HowWorks />, <Outages />];

const SolarPlusStorageHome = () => {
  return <SwipeNav Components={Components}></SwipeNav>;
};

export default SolarPlusStorageHome;
